import type { ExteriorMaterialOverride } from "building-types/materials/materialTypes";
import type { Site, GeneratedSite } from "building-types/site/site";
import GeomTagGroup from "geom/geomTagGroup";
import { buildingEntityBaseNew } from "./buildingEntityTools";

export function siteNew(): Site {
  const name = "Site";
  const sortIndex = 0;
  return {
    ...buildingEntityBaseNew("SITE"),
    name,
    sortIndex,
  } as Site;
}

export function generatedSiteNew(site: Site): GeneratedSite {
  return {
    ...site,
    propPlacements: [],
    siteDatum: [],
    setbackDatum: [],
    sidewalkDatum: [],
    siteShapes: [],
    drivewayGeom: [],
    sidewalkGeom: [],
    sitePlaneGeom: new GeomTagGroup<ExteriorMaterialOverride>(),
    siteWhiteBoxGeom: new GeomTagGroup<ExteriorMaterialOverride>(),
    fenceGeom: [],
    grassGeom: [],
    roadGeom: [],
    curbGeom: [],
    topographyGeom: new GeomTagGroup<ExteriorMaterialOverride>(),
  };
}
